import {forwardRef, SVGProps} from 'react';
import styles from './styles.module.less';
import {join} from '../../utils';

export const CaretDownIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & {fill?: string}>(({fill = '#0088CC', direction, ...props}, ref) =>
	<svg {...props} xmlns='http://www.w3.org/2000/svg' width='11' height='6' viewBox='0 0 11 6' className={join(direction === 'down' && styles.down, styles.icon, props.className)}>
		<path d='M0.0788574 0.5L5.07886 5.5L10.0789 0.5H0.0788574Z' fill={fill}/>
	</svg>);
